// extracted by mini-css-extract-plugin
export var productImage = "_mo-1";
export var viewLink = "_mo-2";
export var wishlistItem = "_mo-0";